export default class Logger {
  static d(tag, message, exception) {
    const formattedMessage = this.formatMessage(tag, message, exception);
    // eslint-disable-next-line no-console
    if (console.debug) {
      console.debug(formattedMessage);
    } else {
      console.info(formattedMessage);
    }
  }

  static i(tag, message, exception) {
    // eslint-disable-next-line no-console
    console.info(this.formatMessage(tag, message, exception));
  }

  static w(tag, message, exception) {
    // eslint-disable-next-line no-console
    console.warn(this.formatMessage(tag, message, exception));
  }

  static e(tag, message, exception) {
    // eslint-disable-next-line no-console
    console.error(this.formatMessage(tag, message, exception));
  }

  static formatMessage(tag, message, exception) {
    // eslint-disable-next-line prefer-template
    return `${tag}: ${message} ${!!exception ? ", " + exception : ""}`;
  }
}
